import { Box, Flex, Text, Progress } from '@mantine/core'
import React from 'react'
import { COLOR_NAMES } from 'Theme'

type DeliveryProgressProps = {
  label?: string
  value: number
}

export const DeliveryProgress = ({
  label = 'Delivery Progress',
  value,
}: DeliveryProgressProps) => (
  <Box>
    {/* Header */}
    <Flex justify="space-between" align="center" mb={16}>
      <Text fw={500} c={COLOR_NAMES.EEIRE_BLACK} fz={14}>
        {label}
      </Text>
      <Text fw={600} c={COLOR_NAMES.PINEY_LAKE}>
        {value}%
      </Text>
    </Flex>

    {/* Progress bar */}
    <Progress
      value={value}
      radius="xl"
      size="lg"
      styles={{
        root: {
          backgroundColor: '#CEE0DD',
        },
        section: {
          backgroundColor: '#126545',
        },
      }}
    />
  </Box>
)
